import { coverFeature1, latestItems } from "@/mocks/archive";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

const TAG_STYLE: Record<string, string> = {
  直播现场: "bg-primary-100 text-primary-800",
  税务关联: "bg-secondary-100 text-secondary-900",
  综艺考古: "bg-accent-100 text-accent-900",
  带货售后: "bg-primary-100 text-primary-800",
  感情线: "bg-accent-100 text-accent-900",
  学历核对: "bg-secondary-100 text-secondary-900",
  品牌切割: "bg-primary-100 text-primary-800",
  现场原声: "bg-secondary-100 text-secondary-900",
};

export default function LatestFeed() {
  const feature = latestItems[0];
  const rest = latestItems.slice(1);

  return (
    <section id="latest" className="border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            tag="NEW"
            kicker="正在发生 · 持续更新"
            title="国产黑料最新猛料"
            desc="近一周在发酵的瓜集中到这里，短讯快速过一遍，想追完整链接着去人物或合集模块深挖。"
          />
        </Reveal>

        <div className="grid gap-5 lg:grid-cols-[0.95fr_1.05fr]">
          {/* 头条大卡：封面驱动 */}
          <Reveal>
            <a
              href="#deep"
              className="group relative flex h-full min-h-[320px] flex-col justify-end overflow-hidden rounded-lg bg-foreground-950 md:min-h-[420px]"
            >
              <img
                src={coverFeature1}
                alt="最新猛料头条封面"
                className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-foreground-950/10"></div>
              <div className="relative p-5 md:p-7">
                <div className="flex items-center gap-2">
                  <span className="flex h-6 items-center rounded-md bg-primary-500 px-2 text-xs font-bold text-background-50">
                    今日头条
                  </span>
                  <span className="text-xs text-background-200/80">{feature.time}</span>
                </div>
                <h5 className="mt-4 font-heading text-lg font-bold leading-snug text-background-50 md:text-2xl">
                  {feature.title}
                </h5>
                <p className="mt-2 hidden text-sm leading-6 text-background-200/90 md:block">{feature.brief}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-accent-300">
                  进深扒档案看全文
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </a>
          </Reveal>

          {/* 右侧密集短讯 */}
          <div className="grid content-start gap-3 sm:grid-cols-2 md:gap-4">
            {rest.map((item, i) => (
              <Reveal key={item.id} delay={(i % 2) * 60}>
                <a
                  href="#year"
                  className="group flex h-full flex-col rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <div className="flex items-center justify-between gap-2">
                    <span className={`inline-flex h-6 items-center rounded-md px-2 text-xs font-medium ${TAG_STYLE[item.tag] ?? "bg-secondary-100 text-secondary-900"}`}>
                      {item.tag}
                    </span>
                    <span className="whitespace-nowrap text-[11px] text-foreground-400">{item.time}</span>
                  </div>
                  <h5 className="mt-3 flex-1 text-sm font-semibold leading-6 text-foreground-900 group-hover:text-primary-700">
                    {item.title}
                  </h5>
                  <span className="mt-3 text-[11px] text-foreground-400">
                    <i className="ri-focus-3-line mr-1 text-xs"></i>按年线归档中
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}